/* Keep each necklace's own Shopify variants, media, price and inventory while
   changing styles without a page navigation. Dawn's product swap replaces the
   product content and updates the URL after the new page has loaded. */
(() => {
  let controller;

  document.addEventListener('click', async (event) => {
    const choice = event.target.closest('button[data-divine-necklace-style]');
    if (!choice || choice.getAttribute('aria-pressed') === 'true') return;

    const fit = choice.closest('.dd-pdp-fit');
    const current = choice.closest('product-info');
    const destination = new URL(choice.dataset.productUrl, location.href);
    if (!current || destination.origin !== location.origin || destination.pathname === location.pathname) return;

    controller?.abort();
    controller = new AbortController();
    const signal = controller.signal;
    const previewTheme = new URLSearchParams(location.search).get('preview_theme_id');
    if (previewTheme) destination.searchParams.set('preview_theme_id', previewTheme);
    fit.querySelector('[data-necklace-error]').hidden = true;
    fit.setAttribute('aria-busy', 'true');
    fit.querySelectorAll('[data-divine-necklace-style]').forEach((button) => { button.disabled = true; });

    try {
      await customElements.whenDefined('product-info');
      if (signal.aborted) return;
      const response = await fetch(destination, { signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('The necklace could not be loaded. Please try again.');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = html.querySelector("product-info[id^='MainProduct']");
      if (!next || !html.querySelector('main') || !html.querySelector('head title')) throw new Error('The necklace could not be loaded. Please try again.');
      if (signal.aborted) return;

      const position = fit.getBoundingClientRect().top;
      current.handleSwapProduct(destination.pathname, true)(html);
      if (previewTheme) {
        const updated = new URL(location.href);
        updated.searchParams.set('preview_theme_id', previewTheme);
        history.replaceState(history.state, '', updated.pathname + updated.search + updated.hash);
      }
      const newFit = document.querySelector("product-info[id^='MainProduct'] .dd-pdp-fit");
      if (newFit) {
        scrollBy(0, newFit.getBoundingClientRect().top - position);
        newFit.closest('product-info')?.querySelector('variant-selects input:checked, variant-selects select')?.focus({ preventScroll: true });
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        const message = fit.querySelector('[data-necklace-error]');
        message.textContent = error.message || 'The necklace could not be loaded. Please try again.';
        message.hidden = false;
      }
    } finally {
      if (!signal.aborted && fit.isConnected) {
        fit.removeAttribute('aria-busy');
        fit.querySelectorAll('[data-divine-necklace-style]').forEach((button) => { button.disabled = false; });
      }
    }
  });
})();
